<div class="modal-header">
    <h2 class="modal-title">{{ "specialOffers.editSegmentationModal.title" | translate }}</h2>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="row justify-content-center mb-3">
            <div class=" col-12">
                <div class="row justify-content-center mb-3">
                    <div class="col-12">
                        <kendo-switch
                            HJSuppress
                            [(ngModel)]="segmentationToggle.segment"
                            class="me-3"  
                            name="segmentationToggle"
                            (valueChange)="changeSegmentFilterHandler($event)">
                        </kendo-switch>
                        <span>{{ "specialOffers.wizard.clientSegmentation.segment" | translate }}</span>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <label class="label-input">
                            {{ "specialOffers.wizard.clientSegmentation.type" | translate }}
                        </label>
                        <div class="input-dropdown-container">
                            <kendo-combobox
                                HJSuppress
                                class="custom-kendo-control-xl"
                                [size]="sizeLarge"
                                [fillMode]="fillModeOutline"
                                [rounded]="roundedLarge"
                                name="segmentTypeNgModel"
                                #segmentTypeNgModel="ngModel"
                                [placeholder]="'specialOffers.wizard.clientSegmentation.placeholder.selectSegmentType' | translate"
                                [clearButton]="false"
                                [valuePrimitive]="true"
                                [disabled]="!segmentationToggle.segment"
                                [data]="segmentTypes"
                                [valueField]="'id'"
                                [textField]="'value'"
                                [(ngModel)]="segmentationData.dictionarySegmentItemTypeExternalEntityId"
                                (ngModelChange)="segmentTypeSelectedHandler($event)"
                                [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                #segmentType
                                (click)="!segmentType.isOpen && !segmentType.disabled ?
                                segmentType.toggle() : null"
                                [required]="segmentationToggle.segment">
                            </kendo-combobox>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <label class="label-input">
                            {{ "specialOffers.wizard.clientSegmentation.segmentValue" | translate }}
                        </label>
                        <div class="input-dropdown-container">
                            <kendo-multiselect
                                HJSuppress
                                class="custom-kendo-control-xl"
                                [size]="sizeLarge"
                                [fillMode]="fillModeOutline"
                                [rounded]="roundedLarge"
                                name="segmentItemsNgModel"
                                #segmentItemsNgModel="ngModel"
                                [placeholder]="'specialOffers.wizard.clientSegmentation.placeholder.selectSegmentValue' | translate"
                                (ngModelChange)="campaignTypeSelectedHandler($event)"
                                [clearButton]="false"
                                [valuePrimitive]="false"
                                [disabled]="!segmentationData.dictionarySegmentItemTypeExternalEntityId"
                                [data]="segmentItems"
                                [valueField]="'id'"
                                [textField]="'value'"
                                [(ngModel)]="selectedSegmentItems"
                                [popupSettings]="{popupClass : 'data-hj-suppress'}"
                                #segmentItem
                                (click)="!segmentItem.isOpen && !segmentItem.disabled ?
                                segmentItem.toggle() : null"
                                [required]="segmentationToggle.segment">
                            </kendo-multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="l-separator"></div>
        <div class="row justify-content-center mb-3">
            <div class=" col-12">
                <div class="row justify-content-center mb-3">
                    <div class="col-12">
                        <kendo-switch
                            HJSuppress
                            [(ngModel)]="segmentationToggle.maximumPaymentDelay"
                            class="me-3"
                            (valueChange)="changeMaximumPaymentDelayHandler($event)"
                            name="maximumPaymentDelayToggle">
                        </kendo-switch>
                        <span>
                            {{ "specialOffers.wizard.clientSegmentation.overdueDays" | translate}}
                        </span>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <label class="label-input">
                            {{ "specialOffers.wizard.clientSegmentation.paymentDelay" | translate }}
                        </label>
                        <div class="input-dropdown-container">
                            <kendo-numerictextbox
                                HJSuppress
                                class="l-numeric-textbox-container"
                                format="n0"
                                [spinners]="false"
                                [min]="0"
                                [(ngModel)]="segmentationData.maximumPaymentDelay"
                                name="maximumPaymentDelayNgModel"
                                #maximumPaymentDelayNgModel="ngModel"
                                placeholder="{{'specialOffers.wizard.clientSegmentation.placeholder.typeOverdueDays' | translate}}"
                                [disabled]="!segmentationToggle.maximumPaymentDelay"
                                [required]="segmentationToggle.maximumPaymentDelay">
                            </kendo-numerictextbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="l-separator"></div>
        <div class="row justify-content-center mb-3">
            <div class="col-12">
                <div class="row justify-content-center mb-3">
                    <div class="col-12">
                        <kendo-switch
                            HJSuppress
                            [(ngModel)]="segmentationToggle.periodUntilTermination"
                            class="me-3"
                            (valueChange)="changePeriodUntilTerminationHandler($event)"
                            name="periodUntilTerminationoggle">
                        </kendo-switch>
                        <span>
                            {{ "specialOffers.wizard.clientSegmentation.periodUntilTermination" | translate}}
                        </span>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <label class="label-input">
                            {{ "specialOffers.wizard.clientSegmentation.period" | translate }}
                        </label>
                        <div class="input-dropdown-container">
                            <kendo-numerictextbox
                                HJSuppress
                                class="l-numeric-textbox-container"
                                format="n0"
                                [spinners]="false"
                                [min]="0"
                                [(ngModel)]="segmentationData.periodUntilTermination"
                                name="periodUntilTerminationNgModel"
                                #periodUntilTerminationNgModell="ngModel"
                                placeholder="{{'specialOffers.wizard.clientSegmentation.placeholder.typePeriodUntilTermination' | translate}}"
                                [disabled]="!segmentationToggle.periodUntilTermination"
                                [required]="segmentationToggle.periodUntilTermination">
                            </kendo-numerictextbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div *ngIf="form.dirty" class="row d-flex justify-content-center text-danger">
        <div class="p-3">
            {{ "specialOffers.editSegmentationModal.confirmationMessage" | translate }}
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="closeHandler()">
        {{ "specialOffers.editSegmentationModal.cancel" | translate }}
    </button>
    <button class="btn primary-btn" (click)="changeHandler()"
        [disabled]="form.invalid">
        {{ "specialOffers.editSegmentationModal.apply" | translate }}
    </button>
</div>
